module.exports = __webpack_public_path__ + "static/media/kw.static.d89a51a4.svg";